
import { css } from 'lit';
export default css`
:host{
  display:block;
}

:host([variant='secondary']) .accordion-trigger{
    color:var(--purple-indigo);
    font-weight:var(--fw-medium);
    font-size:var(--fs-body-mobile);
    line-height:var(--lh-body-mobile);
  }

:host([variant='secondary']) .accordion-trigger:hover,
    :host([variant='secondary']) .accordion-trigger:focus-within{
      color:var(--primary-eggplant);
    }

@media (min-width: 992px){

:host([variant='secondary']) .accordion-trigger{
      font-size:var(--fs-body);
      line-height:var(--lh-body)
  }
    }

:host([variant='secondary']) ::slotted([slot='secondary-label']){
    font-size:var(--fs-sm);
  }

:host([variant='secondary']) .accordion-trigger--icon{
    display:none;
  }

:host([active]) .accordion-trigger{
    --heading-font-weight:var(--fw-medium);
    border-color:var(--purple-indigo);
    color:var(--purple-indigo);
  }

@media print{

.accordion-trigger--icon{
    border-top:none;
    display:none
}
  }

.accordion-trigger{
  display:flex;
  position:relative;
  justify-content:space-between;
  align-items:center;
  transition:color 300ms ease-in-out;
  cursor:pointer;
  border:0px none;
  border-top:2px solid var(--purple-medium-neutral);
  background:transparent;
  padding:var(--spacing-5) var(--spacing-2);
  width:100%;
  color:var(--neutral-charcoal);
  text-align:left;
}

.accordion-trigger:hover,
  .accordion-trigger:focus-within{
    color:var(--purple-indigo);
  }

@media (min-width: 992px){

.accordion-trigger{
    padding:var(--spacing-6) var(--spacing-2)
}
  }

@media print{

.accordion-trigger{
    border-top:none;
    --heading-font-weight:var(--fw-light);
    border-color:var(--purple-indigo);
    color:var(--purple-indigo);
    padding-top:0;
    padding-bottom:0.5rem;
    padding-left:var(--spacing-0)
}
  }

.accordion-trigger--label{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:var(--spacing-3);
}

@media (min-width: 992px){

.accordion-trigger--label{
    flex-direction:row;
    align-items:center;
    gap:var(--spacing-4)
}
  }

::slotted([slot='secondary-label']){
  color:var(--neutral-medium-gray);
  font-size:var(--fs-base);
  line-height:1;
}

@media (min-width: 992px){

::slotted([slot='secondary-label']){
    font-size:var(--fs-lg)
}
  }
`;